const MfaState = {
    empty: '',
    mfaSetupRequired: 'MFA_SETUP',
    mfaChallengeRequired: 'MFA_CHALLENGE',
    mfaSuccess: 'MFA_SUCCESS',
}

export default MfaState;
